import React, { useEffect, useState, Fragment, useRef } from "react";
import { ReportTableContent } from '../../../Common/Table/tableContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const data = this.props.data;
        const searchData = this.props.searchData;
        const subNames = this.props.contentRowNames;
        const colName = this.props.initialData;
        const summeryValues = this.props.summeryValues;
        const summeryData = this.props.summeryData;

        return (
            <div className="p-2">
                <h3><center><u>Labour Checklist Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.collectionPoint}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <TableContainer component={Paper}>
                    <div className="row alternative_cls bg-light  ">
                        {summeryData.map((item) => (
                            <div style={{ marginLeft: '15px' }} className="card-body width2"><p><b><p />{item.name.substring(0, item.name.length - 1)} Total :</b> {parseFloat(item.value).toFixed(2)} </p> </div>
                        ))}
                        <div className="card-body width1"><p><b><p />Total :</b> {parseFloat(summeryValues.allTotal).toFixed(2)}</p> </div>
                        <div className="card-body width2"><p><b><p />Full :</b> {summeryValues.full} </p> </div>
                        <div className="card-body width3"><p><b><p />Half : </b>{summeryValues.half}</p> </div>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>Reg No</TableCell>
                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Employee Name
                                    </TableCell>
                                    {colName.map((item) => (
                                        <TableCell colSpan={2} style={{ fontWeight: "bold" }} align='center'>{item}</TableCell>
                                    ))}
                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Total
                                    </TableCell>
                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Duration
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    {subNames.map((item) => {
                                        var res = item.slice(-1);
                                        return (
                                            <TableCell style={{ fontWeight: "bold" }} align='right'>{res == 'N' ? 'Kg' : 'Field'}</TableCell>
                                        );
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row) => (
                                    <TableRow key={row.registrationNumber}>
                                        <TableCell align="left" component="th" scope="row">
                                            {row.registrationNumber}
                                        </TableCell>
                                        <TableCell align="left">{row.firstName}</TableCell>
                                        {subNames.map((column) => {
                                            const value = row[column];
                                            var res = column.slice(-1);
                                            return (
                                                <TableCell align='right'>{value == undefined ? '-' : res == 'N' ? parseFloat(value).toFixed(2) : value}</TableCell>
                                            );
                                        })}
                                        <TableCell align="center">{parseFloat(row.total).toFixed(2)}</TableCell>
                                        <TableCell align="center">{row.total >= row.configurationValue ? 'Full' : 'Half'}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </TableContainer>
            </div>
        );
    }
}


